<script setup lang="ts">
const stockAndDelivery = inject('stockAndDelivery')
</script>

<template>
  <LazyUiDialog
    name="stock-and-delivery-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ stockAndDelivery.Title }}</span>
    </template>

    <StrapiBlocksText
      v-if="stockAndDelivery?.Richtext"
      :nodes="stockAndDelivery.Richtext"
    />

    <!-- <pre>{{ stockAndDelivery.Richtext }}</pre> -->
  </LazyUiDialog>
</template>
